import { render } from "preact";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RateProductWidget } from "../components/RateProductWidget";
import styles from "../index.css?inline";
import "../index.css";

const WIDGET_HOST_ID = "social-ocean-rate-product-host";
const MOUNT_SELECTOR = "[data-social-ocean-rate-product]";

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, retry: 1 } },
});

export function mountRateProductWidget(target: HTMLElement) {
  if (document.getElementById(WIDGET_HOST_ID)) return;
  const host = document.createElement("div");
  host.id = WIDGET_HOST_ID;
  host.style.display = "block";
  host.style.width = "100%";
  target.appendChild(host);

  const shadow = host.attachShadow({ mode: "open" });
  const rootWrapper = document.createElement("div");
  rootWrapper.className = "so-widget-root";
  rootWrapper.style.isolation = "isolate";
  shadow.appendChild(rootWrapper);

  try {
    const styleSheet = new CSSStyleSheet();
    styleSheet.replaceSync(styles);
    shadow.adoptedStyleSheets = [styleSheet];
  } catch {
    const style = document.createElement("style");
    style.textContent = styles;
    shadow.appendChild(style);
  }

  render(
    <QueryClientProvider client={queryClient}>
      <RateProductWidget />
    </QueryClientProvider>,
    rootWrapper,
  );
}

if (typeof window !== "undefined") {
  const init = () => {
    if (document.getElementById(WIDGET_HOST_ID)) return;
    const target = document.querySelector<HTMLElement>(MOUNT_SELECTOR);
    if (target) mountRateProductWidget(target);
  };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
}
